import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../reusableComponents/components/generics/TextInput";
import { Form, Field } from "react-final-form";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { resetPassword } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RESET_SUCCESS } from "../utils/constant";

const GridPadding = styled(Grid)({
  marginTop: "2rem",
  marginBottom: "2rem",
});

function ResetPasswordForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSuccess, setIsSeucess] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [token, setToken] = useState("");
  const ResetSuccess = useSelector((state) => state);
  useEffect(() => {
    if (ResetSuccess?.profileReducer?.resetResponseData?.setPassword?.success) {
      setIsSeucess(
        ResetSuccess?.profileReducer?.resetResponseData?.setPassword?.success
      );
    }
  }, [ResetSuccess]);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);
  if (isSuccess) {
    navigate(RESET_SUCCESS);
  }
  const onSubmit = async (values) => {
    const respone = await dispatch(resetPassword(values));
  };
  const validate = (values) => {
    const errors = {};
    if (!values.userName) {
      errors.userName = t("Field is required");
    }

    if (!values.newPassword) {
      errors.newPassword = t("Field is required");
    }

    if (!values.reTypePassword) {
      errors.reTypePassword = t("Please re-type the New Password");
    } else if (values.reTypePassword !== values.newPassword) {
      errors.reTypePassword = t("Passwords do not match");
    }

    return errors;
  };

  return (
    <Grid item xs={12} className="sign-in-input">
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {t("Reset Password")}
      </Typography>
      <Grid container>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
            errors,
          }) => {
            return (
              <Grid item xs={12}>
                <form onSubmit={handleSubmit}>
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="userName"
                        component={TextInput}
                        label={t("Please enter UserName")}
                        type={"text"}
                        required={true}
                        error={errors.userName}
                        placeholder={t("Please enter UserName")}
                      />
                    </GridPadding>
                    <GridPadding>
                      <Field
                        name="newPassword"
                        component={TextInput}
                        label={t("Please enter New Password")}
                        // type={showPassword ? "text" : "password"}
                        required={true}
                        error={errors.newPassword}
                        placeholder={t("Please enter New Password")}
                        // showPassword={showPassword}
                        // handleMouseDownPassword={handleMouseDownPassword}
                        // handleClickShowPassword={handleClickShowPassword}
                        password={"password"}
                      />
                    </GridPadding>
                    <GridPadding>
                      <Field
                        name="reTypePassword"
                        component={TextInput}
                        label={t("Re-type New Password")}
                        // type={showNewPassword ? "text" : "password"}
                        required={true}
                        error={errors.reTypePassword}
                        placeholder={t("Re-type New Password")}
                        // showNewPassword={showNewPassword}
                        // handleMouseDownNewPassword={handleMouseDownNewPassword}
                        // handleClickShowNewPassword={handleClickShowNewPassword}
                        password={"password"}
                      />
                    </GridPadding>
                  </Grid>
                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={
                      submitting || pristine || Object.keys(errors).length > 0
                    }
                  >
                    {t("Reset Password")}
                  </Button>
                </form>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
}

export default ResetPasswordForm;
